import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { FixedLimitService } from '../../service/limit-flow-proposal/fixed-limit.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmComponent } from '../../../shared/confirm/confirm.component';

import * as moment from 'moment';
import 'moment/locale/pt-br';
import { IMyDpOptions } from 'mydatepicker';

export interface RequestFixedModel {
	approvalFinanceGroup: [{
		Integrante: string,
		LimiteSugerido: string,
		VigenciaSugerida: string,
		VigenciaFimSugerida: any,
		LC: any,
		Vigencia: string,
		VigenciaFim: any,
		ContaClienteID: string
	}];
	proposalID: string;
	approvalLC: number;
	aprovalFinal: boolean;
	group: number;
}

@Component({
	selector: 'app-fixed-limit',
	templateUrl: './fixed-limit.component.html',
	styleUrls: ['./fixed-limit.component.scss'],
	providers: [
		FixedLimitService
	]
})

export class FixedLimitComponent extends DialogComponent<RequestFixedModel, boolean> implements RequestFixedModel {

	approvalFinanceGroup: [{
		Integrante: string,
		LimiteSugerido: string,
		VigenciaSugerida: string,
		VigenciaFimSugerida: any,
		LC: any,
		Vigencia: string,
		VigenciaFim: any,
		ContaClienteID: string,
		PropostaLCId: string,
		Rating: string
	}];
	group: number = 0;
	proposalID: string;
	approvalLC: number;
	aprovalFinal = false;
	total: number;

	integrantes: any[] = [];

	private today = new Date();

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		disableSince: { year: this.today.getFullYear() + 1, month: this.today.getMonth() + 1, day: this.today.getDate() + 1 },
		disableUntil: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() - 1 },
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

	constructor(dialogService: DialogService, private router: Router, private flashMessagesService: FlashMessagesService, private fixedLimiteService: FixedLimitService) {
		super(dialogService);
	}

	ngOnInit() {
		if (this.approvalFinanceGroup.length > 1) {
			this.approvalFinanceGroup.forEach(element => {
				if (element.VigenciaFimSugerida) {
					var date = moment(element.VigenciaFimSugerida);
					element.VigenciaFim = { date: { year: date.year(), month: date.month() + 1, day: date.date() } };
				}
				element.LC = element.LimiteSugerido;
			});
		} else {
			if (this.approvalFinanceGroup[0].VigenciaFimSugerida) {
				var date = moment(this.approvalFinanceGroup[0].VigenciaFimSugerida);
				this.approvalFinanceGroup[0].VigenciaFim = { date: { year: date.year(), month: date.month() + 1, day: date.date() } };
			}
			this.approvalFinanceGroup[0].LC = this.approvalFinanceGroup[0].LimiteSugerido;
		}
	}

	validateDate(date, i) {
		var max = moment(new Date()).add(1, 'year');
		if (moment(date.jsdate) > max) {
			this.approvalFinanceGroup[i].VigenciaFim = null;
			this.flashMessagesService.show("A vigência final não pode ser maior que um ano.", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	getTotal() {
		let total = 0;
		for (var i = 0; i < this.approvalFinanceGroup.length; i++) {
			if (this.approvalFinanceGroup[i].LC) {
				total += this.approvalFinanceGroup[i].LC;
				this.total = total;
			}
		}
		return total;
	}

	garanteVigencia() {
		let vigenciaEmpty = false;

		this.approvalFinanceGroup.forEach(element => {
			if (!element.VigenciaFim ||
				!element.VigenciaFim.date.year ||
				!element.VigenciaFim.date.month ||
				!element.VigenciaFim.date.day) {
				vigenciaEmpty = true;
			}
		});

		if (vigenciaEmpty) {
			this.flashMessagesService.show("Não é possível fixar limite sem uma vigência válida.", { cssClass: 'alert-danger', timeout: 6000 });
		}

		return !vigenciaEmpty;
	}

	fixLimit() {

		if (this.garanteVigencia()) {

			var message = 'Confirma a fixação dos limites preenchidos?';
			let disposable = this.dialogService.addDialog(ConfirmComponent, {
				title: 'Confirmação de Fixação',
				message: message
			},
				{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
				.subscribe((isConfirmed) => {
					//We get dialog result
					if (isConfirmed) {
						if (this.aprovalFinal) {
							this.fixLimitList();
						} else {
							this.fixLimitPartialList();
						}
					}
					else {
						//Do nothing here
					}
				});

		}
	}

	fixLimitPartialList() {
		this.approvalFinanceGroup.forEach(element => {
			element.VigenciaFim = element.VigenciaFim.date.year + "-" + element.VigenciaFim.date.month + "-" + element.VigenciaFim.date.day;
		});
		this.fixedLimiteService.fixLimitPartialList(this.approvalFinanceGroup).subscribe(result => {
			if (result.Success) {
				this.result = true;
				this.close();
			} else {
				this.result = false;
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	fixLimitList() {
		this.approvalFinanceGroup.forEach(element => {
			element.VigenciaFim = element.VigenciaFim.date.year + "-" + element.VigenciaFim.date.month + "-" + element.VigenciaFim.date.day;
		});
		this.fixedLimiteService.fixLimitList(this.approvalFinanceGroup).subscribe(result => {
			if (result.Success) {
				this.result = true;
				this.close();
			} else {
				this.result = false;
				this.close();
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/fixed-limit/fixed-limit.component.ts